import { gql } from "@apollo/client/core";

export const getCurrentUserDetailsQuery = gql`
    query GetLoggedInCustomer($email: String!) {
        customer(emailAddress: $email) {
            id
        }
    }
`;

export const getCustomerTransactionsQuery = gql`
    query GetCustomerTransactions(
        $id: String!
        $limit: Int!
        $offset: Int!
        $startDate: String
        $endDate: String
        $filters: TransactionFiltersInput
        $quicksearch: String
    ) {
        customerTransactionsFeed(
            id: $id
            limit: $limit
            offset: $offset
            startDate: $startDate
            endDate: $endDate
            filters: $filters
            quicksearch: $quicksearch
        ) {
            items {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
            total
        }
    }
`;

export const setTransactionDesignName = gql`
    mutation SetTransactionDesignName($id: String!, $name: String!) {
        transactionUpdate(id: $id, designName: $name) {
            id
            designName
        }
    }
`;

export const duplicateTransactionMutation = gql`
    mutation DuplicateTransaction($id: String!, $template: Boolean!) {
        transactionDuplicate(id: $id, template: $template) {
            id
            workflowViewerLink
        }
    }
`;

export const getCustomerBundlesQuery = gql`
    query GetCustomerBundles($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset) {
            items {
                id
                workflowViewerLink
                createdAt
                dispatchDate
                purchaseOrder
                name
                ordered
            }
            total
        }
    }
`;

export const getTransactionsForBundleQuery = gql`
    query GetTransactionsForBundle($id: String!) {
        bundles(ids: [$id]) {
            id
            transactions {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
        }
    }
`;

export const setBundleName = gql`
    mutation SetBundleName($id: String!, $name: String!) {
        bundleUpdate(id: $id, name: $name) {
            id
            name
        }
    }
`;

export const duplicateBundleMutation = gql`
    mutation DuplicateBundle($id: String!, $template: Boolean!) {
        bundleDuplicate(id: $id, template: $template) {
            id
            workflowViewerLink
        }
    }
`;

export const getTemplateBundlesQuery = gql`
    query GetBundleTemplates($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: true) {
            items {
                id
                workflowViewerLink
                createdAt
                name
                ordered
            }
            total
        }
    }
`;
